import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import config from "../../../../config/config";
import moment from "moment";
import { snackActions } from '../../../sc-utilities/SnackBar';
import * as actionDownload from '../../../sc-downloadAll/store/downloadActions';
import { downloadFile } from '../../../sc-utilities';
import { socket } from '../../../../index';
import { download } from '../../../sc-utilities/download.utils';
import * as snackbarActions from '../../../sc-utilities/snackbar/store/snackbarActions';
import {MOBILE}  from "../../../sc-utilities/snackbar/store/actionTypes";
import snackbarStore from "../../../../snackbarStore";

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'products/mobileProduct',
    pluginName: 'PRODUCT',
    entityName: 'MOBILE_PRODUCT',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    lazyLoad: true

});

export const downloadReport = (params) => {
    return async _dispatch => {
        const IDs = params.MobileProductIDs;
        const ErasureReportType = params.ErasureReportType;
        try {
            snackbarStore.dispatch(snackbarActions.showType({type: MOBILE, selectedNumber: IDs.length}));
            let token = localStorage.getItem('SESSION');

            for (const productID of IDs) {

                const objectURL = `${config.backend_domain}:${config.backend_port}/report/download?ProductID=${productID}&ErasureReportType=${ErasureReportType}&ActiveCustomerID=${params.ActiveCustomerID}&Token=${token}`;

                let filename = `securaze_report.pdf`;

                let response = await fetch(objectURL, { method: 'GET', headers: { 'Content-Type': 'application/pdf' } });
                if (response.status === 200) {
                    const contentDisposition = response.headers.get('Content-Disposition').split(';');
                    for (const item of contentDisposition) {
                        if (item.includes('filename')) {
                            filename = item.split('=')[1];
                        }
                    }
                    let blob = await response.blob();

                    // Create blob link to download
                    const url = window.URL.createObjectURL(
                        new Blob([blob]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        filename,
                    );

                    // Append to html link element page
                    document.body.appendChild(link);

                    // Start download
                    link.click();

                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                } else {
                    snackActions.snackBar({
                        message: `File not found for one of selected files (${productID}).`,
                        options: {
                            variant: 'error'
                        }
                    });
                }
                snackbarStore.dispatch(snackbarActions.incrementCounter(MOBILE));
            }
        } catch (error) {
            console.log(error);
            snackActions.snackBar({
                message: `File not found.`,
                options: {
                    variant: 'error'
                }
            });
        }
        snackbarStore.dispatch(snackbarActions.resetSnackbarCounter(MOBILE))
    }
}

// Fetch mobile products action creators
export const fetchMobileProductInit = () => {
    return crudActions.fetchInit();
};
export const fetchMobileProductStart = () => {
    return crudActions.fetchStart();
};
export const fetchMobileProductSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchMobileProductFail = () => {
    return crudActions.fetchFail();
};

export const fetchMobileProductCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        // dispatch(fetchMobileProductInit());
        try {
            let countRes = await rest.post("/products/mobileProduct/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    // dispatch(fetchMobileProductSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchMobileProductFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch mobile product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            // dispatch(fetchMobileProductFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch mobile product."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchMobileProduct = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        // dispatch(fetchMobileProductInit());
        try {
            let listRes = await rest.post("/products/mobileProduct/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                // dispatch(fetchMobileProductSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data.products
            }
            // dispatch(fetchMobileProductFail());
            return []

        } catch (error) {
            // dispatch(fetchMobileProductFail());
            return []
        }
    }
}

// Load mobile product action creators
export const loadMobileProductInit = () => {
    return crudActions.loadInit();
};
export const loadMobileProductStart = () => {
    return crudActions.loadStart();
};
export const loadMobileProductSuccess = loadedMobileProduct => {
    return crudActions.loadSuccess(loadedMobileProduct);
};
export const loadMobileProductFail = error => {
    return crudActions.loadFail(error);
};

export const loadMobileProduct = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(loadMobileProductStart());
        try {
            let res = await rest.post('products/mobileProduct/load', params);
            if (res.data && res.data.succeeded) {
                dispatch(loadMobileProductSuccess(res.data.result.data ?? false));
                return res.data.result.data;
            }
            dispatch(loadMobileProductFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot load mobile product."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot load mobile product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(loadMobileProductFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Create mobile product action creators
export const createMobileProductInit = () => {
    return crudActions.createInit();
};
export const createMobileProductStart = () => {
    return crudActions.createStart();
};
export const createMobileProductSuccess = createdMobileProduct => {
    return crudActions.createSuccess(createdMobileProduct);
};
export const createMobileProductFail = error => {
    return crudActions.createFail(error);
};
export const createMobileProduct = mobileProduct => {
    return async dispatch => {
        await crudActions.create(dispatch, mobileProduct);
    };
};

// Edit mobile product action creators
export const editMobileProductInit = () => {
    return crudActions.editInit();
};
export const editMobileProductStart = () => {
    return crudActions.editStart();
};
export const editMobileProductSuccess = editedMobileProduct => {
    return crudActions.editSuccess(editedMobileProduct);
};
export const editMobileProductFail = error => {
    return crudActions.editFail(error);
};
export const editMobileProduct = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editMobileProductStart());
        try {
            let res = await rest.post('products/mobileProduct/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated mobile product.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editMobileProductFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit mobile product."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit mobile product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editMobileProductFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete mobile products action creators
export const bulkDeleteMobileProductsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteMobileProductsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteMobileProductsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteMobileProductsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteMobileProducts = mobileProducts => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, mobileProducts);
    };
};

// Delete mobile product action creators
export const deleteMobileProductInit = () => {
    return crudActions.deleteInit();
};
export const deleteMobileProductStart = () => {
    return crudActions.deleteStart();
};
export const deleteMobileProductSuccess = deletedMobileProduct => {
    return crudActions.deleteSuccess(deletedMobileProduct);
};
export const deleteMobileProductFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteMobileProduct = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

// custom functions
export const fetchGrades = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/grades/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const grades = [];
                for (var grade of res.data.result.data) {
                    grades.push({ value: grade.GradeID, displayValue: `${grade.InternationalGrading} (${grade.Condition})` });
                }
                return grades;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

export const fetchGradingCategories = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/grading_category/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const gradingCategories = [];
                for (var category of res.data.result.data) {
                    gradingCategories.push({ value: category.GradingCategoryID, displayValue: category.Product });
                }
                return gradingCategories;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

export const fetchTypicalProblems = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/typical_problems/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                let typicalProblems = [];
                for (var tp of res.data.result.data) {
                    if (tp.GradingCategory && tp.GradingCategory.Product) {
                        tp.GradingCategory.Product = tp.GradingCategory.Product.replace('unknown', 'All');
                    }
                    typicalProblems.push({ value: tp.TypicalProblemID, label: `${tp.LongName}${tp.GradingCategory ? ` - ${tp.GradingCategory.Product}` : ''}` });
                }
                return typicalProblems;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

export const downloadRawData = (ProductID, customerID) => {
    let token = localStorage.getItem('SESSION');

    return async dispatch => {
        return fetch(`${config.backend_domain}:${config.backend_port}/products/get_raw_data?ProductID=${ProductID}&ActiveCustomerID=${customerID.ActiveCustomerID}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            let fileName = `${moment().valueOf()}.txt`;
            response.headers.forEach((value, key) => {
                if (key === 'filename') {
                    fileName = value;
                }
            });
            if (response.status === 200) {
                return { status: 200, blob: await response.blob(), fileName: fileName }
            }
            try {
                let responseText = await response.text();
                responseText = JSON.parse(responseText);
                return {
                    status: response.status,
                    message: responseText.message
                }
            } catch (error) {
                return {
                    status: response.status,
                    message: null
                }
            }
        });
    }
};

export const createFromExternal = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/unpairedPalette/createFromExternal', data);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Palette created."}`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create palette."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            return false;
        }
    };
}

export const generateReport = (mobileProduct, translations) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            console.log(socket.id);
            mobileProduct['SocketID'] = socket.id.split('#')[1];
            dispatch({ type: 'START_GENERATE' });
            snackActions.snackBar({
                message: translations['generating_report'] || `Erasure report generation started.`,
                options: {
                    variant: 'success'
                }
            });

            let res = await rest.post('report/generate', mobileProduct);
            if (res.data && res.data.succeeded) {
                const redisTopic = res.data.result.data.RedisTopic;
                socket.once(redisTopic, async msg => {
                    const { Message, Status, ErasureReportID } = msg;
                    if (Status !== 'generated') {
                        snackActions.snackBar({
                            message: Message ?? (translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`),
                            options: {
                                variant: 'error'
                            }
                        });
                        dispatch({ type: 'FINISH_GENERATE' });
                        return false;
                    }
                    const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ActiveCustomerID=${mobileProduct.ActiveCustomerID}`;
                    await download(objUrl);
                    snackActions.snackBar({
                        message: translations['generating_report'] || `Erasure report generation finished.`,
                        options: {
                            variant: 'success'
                        }
                    });
                    dispatch({ type: 'FINISH_GENERATE' });

                });
            } else {
                snackActions.snackBar({
                    message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

export const fetchPrinters = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/printers/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const printers = [];
                for (var printer of res.data.result.data) {
                    printers.push({ value: printer.PrinterID, displayValue: `${printer.Name} (${printer.PrinterType} / ${printer.ConnectionType})` });
                }
                return printers;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

// custom functions
export const isPrintedLabel = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/is-printed', data);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Successfully printed label."}`,
                    options: {
                        variant: 'success'
                    }
                });

                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot print label."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            return false;
        }
    };
}

export const printLabel = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/print_label', data);
            if (res.data && res.data.succeeded) {
                return res.data.status === 200;
            }
            else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
}

export const fetchOrders = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('palettes/order/list', { ...id, listAll: true, formatForWEBUI: true, productChangePalette: true });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;
            return response ? response : [];
        } catch (error) {
            return [];
        }
    }
}

export const moveToAnotherPalette = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/mobileProduct/change_palette', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot change palette."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}

export const bulkPrintLabels = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/mobileProduct/bulk_print_label', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot print label."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        }
        catch (error) {
            return [];
        }
    }
}

export const bulkGenerateReports = (data, translations) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            console.log(socket.id);
            data['SocketID'] = socket.id.split('#')[1];;
            let res = await rest.post('products/mobileProduct/bulk_generate_report', data);
            if (res.data.status === 200) {
                for (const redisTopic of res.data.result.data.RedisTopics) {
                    socket.once(`${redisTopic}|0`, () => {
                        snackActions.snackBar({
                            message: translations['generate_report_start'] || `Erasure report starting.`,
                            options: {
                                variant: 'info'
                            }
                        });

                        socket.once(`${redisTopic}|2`, async msg => {
                            if (msg.Message.name === 'ERROR') {
                                snackActions.snackBar({
                                    message: msg.Message?.data?.message ?? (translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`),
                                    options: {
                                        variant: 'error'
                                    }
                                });
                                return false;
                            }
                            const reportID = msg.Message.data;
                            const filename = msg.Message.name;

                            let file = await dispatch(actionDownload.downloadErasure(reportID, data.ActiveCustomerID, filename, translations));
                            if (file) {
                                downloadFile(file, filename);
                            }
                        });
                    });
                }
                return true;
            }
            else {
                snackActions.snackBar({
                    message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}

export const unpairExternal = externalID => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/mobileProduct/unpair', { ProductExternalInfoID: externalID.data, ActiveCustomerID: externalID.ActiveCustomerID });
            return res.data.status === 200;
        } catch (error) {
            return false;
        }
    };
}

export const unpairBulkExternalMobile = externalIDs => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/mobileProduct/bulk_unpair', { ProductExternalInfoIDs: externalIDs.data, ActiveCustomerID: externalIDs.ActiveCustomerID });
            return res.data.status === 200;
        } catch (error) {
            return false;
        }
    };
}

export const setMobileProduct = (data) => {
    return ({
        type: 'HANDLE_MOBILE_PRODUCT',
        productMobile: data
    });
}

export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        baseboard: data
    });
}

export const galleryTrue = () => {
    return ({
        type: 'GALLERY_OPEN_MOBILE',
    });
}

